<template>
  <header>
    <button
      v-if="getUserInitials"
      title="Menü öffnen"
      :class="{ 'open': sidebarFixed }"
      class="d-none d-md-block"
      @click="toggleSidebar()"
    >
      <span />
    </button>
    <nav class="navbar navbar-expand">
      <div class="container-fluid l2" tabindex="0" role="region" aria-label="Navigation">
        <Component
          :is="logoHref ? 'a' : 'span'"
          v-if="getIsActive"
          class="flex items-center gap-4 navbar-brand"
          :href="logoHref"
          @click="getTenantsCount > 1 ? tenantSwitch($event) : null"
        >
          <img
            :src="logoUrl"
            :alt="logoAlt"
            loading="lazy"
          >
          <i
            v-if="getTenantsCount > 1"
            class="fa-thin fa-fw fa-chevron-down"
          />
        </Component>
        <a
          v-if="!getIsActive"
          class="nav-link"
          href="/login"
        >
          <span class="d-none d-md-inline">
            <i class="far fa-user-circle fa-2x" /><br>
            @lang('Anmelden')
          </span>
          <span class="d-md-none">
            <i class="far fa-sign-in fa-2x" /><br>
          </span>
        </a>
        <div
          v-if="getIsActive && getUserInitials"
          class="navbar-nav align-items-center text-center gap-8"
        >
          <div class="col" />
          <IoInboxMenuItem
            v-if="inboxUrl"
            :endpoint="notificationsRequest"
            :history="inboxUrl"
            :markasseen="markAsSeen"
          />
          <a
            v-if="compassUrl"
            class="nav-link text-body d-none d-md-flex profile-toggle gap-2"
            :href="compassUrl"
            target="_blank"
            rel="noopener noreferrer"
            :title="compassTitle"
          >
            <img
              class="compass-handbook-icon"
              :src="compassIconUrl"
              width="36"
              height="36"
              alt=""
              aria-hidden="true"
            >
            <span class="nav-link-label">
              {{ compassLabel }}
            </span>
          </a>
          <div class="dropdown d-none d-md-block">
            <a
              id="header-profile-toggle"
              class="nav-link text-body dropdown-toggle profile-toggle gap-2"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              title="Mein Profil"
            >
              <BaseBadge
                :size="36"
                filled="company-main-primary"
                pill
              >
                {{ getUserInitials }}
              </BaseBadge>
              <span class="nav-link-label">
                {{ getUserName }}
              </span>
            </a>
            <div
              class="dropdown-menu dropdown-menu-right"
              aria-labelledby="header-profile-toggle"
            >
              <a
                v-for="(menuItem, inx) in menuMain"
                :key="`header-menu-main-${ inx }`"
                :href="menuItem.url"
                class="dropdown-item"
                v-html="menuItem.label"
              />
              <hr v-if="menuMain.length && menuCommon.length">
              <a
                v-for="(menuItem, inx) in menuCommon"
                :id="menuItem.id"
                :key="`header-menu-common-${ inx }`"
                :href="menuItem.url"
                class="dropdown-item"
                v-html="menuItem.label"
              />
              <hr v-if="(menuMain.length || menuCommon.length) && logoutAction">
              <template v-if="logoutAction">
                <a
                  v-for="item in dropdownItems"
                  :key="item.label"
                  :href="item.url"
                  class="dropdown-item"
                >
                  {{ item.label }}
                </a>
                <a
                  v-if="isBase"
                  class="dropdown-item"
                  :href="profileAction"
                >
                  Profil
                </a>
                <button
                  class="dropdown-item"
                  @click="logout()"
                >
                  {{ logoutTitle }}
                </button>
                <BaseForm
                  style="display: none"
                  name="logout-form"
                  :action="logoutAction"
                  method="post"
                  empty
                  token
                />
              </template>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
import {
  mapState,
  mapMutations,
} from 'vuex';
import IoMediaQueryMixin from '../shared/mixins/IoMediaQueryMixin';
import compassIconUrl from '../../images/compass-icon.png';

export default {
  name: 'BaseHeader',
  mixins: [
    IoMediaQueryMixin,
  ],
  data() {
    return {
      compassIconUrl,
    };
  },
  props: {
    app: {
      type: String,
      default: '',
    },
    logoUrl: {
      type: String,
      default: '',
    },
    logoHref: {
      type: String,
      default: '',
    },
    logoAlt: {
      type: String,
      default: '',
    },
    userName: {
      type: String,
      default: '',
    },
    userInitials: {
      type: String,
      default: '',
    },
    menuMain: {
      type: Array,
      default: () => ([]),
    },
    menuCommon: {
      type: Array,
      default: () => ([]),
    },
    user: {
      type: [String, Object],
      default: () => ({}),
    },
    logoutAction: String,
    logoutTitle: {
      type: String,
      default: 'Abmelden',
    },
    profileAction: String,
    tenantsCount: {
      type: [Number, String],
      default: () => 1,
    },
    isActive: {
      type: [Boolean, String],
      default: () => false,
    },
    dropdownItems: {
      type: Array,
      default: () => ([]),
    },
    inboxUrl: {
      type: String,
      default: '',
    },
    notificationsRequest: {
      type: String,
      default: '',
    },
    markAsSeen: {
      type: String,
      default: '',
    },
    compassUrl: {
      type: String,
      default: '',
    },
    compassLabel: {
      type: String,
      default: 'RedtreeCompass',
    },
    compassTitle: {
      type: String,
      default: 'Handbuch öffnen',
    },
  },
  computed: {
    ...mapState([
      'sidebarFixed',
    ]),
    getIsActive() {
      return !!parseInt(this.isActive, 10);
    },
    getTenantsCount() {
      return parseInt(this.tenantsCount, 10);
    },
    getUser() {
      return this.user instanceof Object ? this.user : JSON.parse(this.user);
    },
    getUserName() {
      if (this.userName) {
        return this.userName;
      } if ('profile' in this.getUser) {
        return `${this.getUser.profile.firstName} ${this.getUser.profile.lastName}`;
      }
      return '';
    },
    getUserInitials() {
      if (this.userInitials !== '') {
        return this.userInitials;
      }

      const names = this.getUserName.split(' ');
      let initials = names[0].substring(0, 1).toUpperCase();

      if (names.length > 1) {
        initials += names[names.length - 1].substring(0, 1).toUpperCase();
      }

      return initials;
    },
    isBase() {
      return this.app === 'base';
    },
  },
  mounted() {
    // eslint-disable-next-line no-underscore-dangle
    const match = this._media(1400, true, 'max');
    this.toggleSidebar(this.sidebarFixed && !match);
  },
  methods: {
    ...mapMutations({
      toggleSidebar: 'TOGGLE_SIDEBAR_FIXED',
    }),
    logout() {
      if (this.isBase) {
        window.location.href = this.logoutAction;
      } else {
        window.GlobalEvents.fire('logout-form.submit.form');
      }
    },
    tenantSwitch(e) {
      e.preventDefault();

      if (this.tenantsCount > 1) {
        window.GlobalEvents.fire('toggle-tenant-switch');
      }
    },
  },
  watch: {
    mediaQuery: {
      deep: true,
      handler(mq) {
        this.toggleSidebar(this.sidebarFixed && !mq.default.match);
      },
    },
  },
};
</script>

<style scoped lang="scss">
.profile-toggle {
  display: flex;
  align-items: center;
  flex-direction: column;

  &:hover {
    text-decoration: none;
  }
}
.dropdown-item {
  text-decoration: none;
}
.navbar-brand {
  cursor: pointer;
}
.nav-link-label {
  font-size: 0.75rem;
}
.base-badge {
  text-decoration: none;
}
.compass-handbook-icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  display: block;
  flex-shrink: 0;
}
</style>
